import React from 'react';
import { Badge } from '@/components/ui/badge';
import CardTramite from '../../CardTramite';
import { TabConfig } from '../tabsConfig';
import { getCardTramiteProps, getTotalCount } from '../helpers';

export interface TabContentProps {
  tab: TabConfig;
  tramite: any;
  canManageTramites: boolean;
}

const TabContent: React.FC<TabContentProps> = ({
  tab,
  tramite,
  canManageTramites,
}) => {
  if (tab.Component) {
    return <tab.Component tab={tab} tramite={tramite} />;
  }

  if (!tab.items) {
    return null;
  }

  const totalCount = getTotalCount(tab.items, tab, tramite);

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-2 mb-4 sm:mb-6">
        <div className="flex items-center gap-2">
          <tab.icon className="w-5 h-5 text-gray-600" />
          <h3 className="text-lg font-semibold text-gray-900">{tab.label}</h3>
        </div>
        {canManageTramites && totalCount !== null && (
          <Badge variant="outline" className="w-fit sm:ml-auto">
            {totalCount} {totalCount === 1 ? 'trámite' : 'trámites'}
          </Badge>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        {tab.items.map((item) => (
          <CardTramite
            key={`${tab.id}-${item.key}`}
            {...getCardTramiteProps(item, tab, tramite)}
          />
        ))}
      </div>
    </div>
  );
};

export default TabContent;